import { render, RenderResult } from '@testing-library/react';
import React, { lazy, Suspense } from 'react';
import { Navigate, useRoutes, MemoryRouter } from 'react-router-dom';

import { SplashScreen } from 'src/components/loading-screen';
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { DefaultLayout } from 'src/layouts';

import { paths } from '../paths';
import { authRoutes } from './auth';
import { errorRoutes } from './error';

// PAGE_IMPORTS
const BenefitsList = lazy(() => import("../../modules/benefits-list/benefits-list/benefits-list"));
const Home = lazy(() => import("../../modules/home/home/home"));

export const renderWithRouter = (ui: React.ReactElement): RenderResult => render(<MemoryRouter>{ui}</MemoryRouter>);

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <Suspense fallback={<SplashScreen />}>
          {/* <DefaultLayout> */}
          <Navigate to={PATH_AFTER_LOGIN} replace />
          {/* </DefaultLayout> */}
        </Suspense>
      ),
    },
    ...authRoutes,

    // RELATION_PATH_PAGES
    {
      path: paths.benefitsList.root, element:
        // <AuthGuard>
        <DefaultLayout>
          <BenefitsList />
        </DefaultLayout>
      /* </AuthGuard> */
    },
    {
      path: paths.home.root, element:
        // <AuthGuard>
        <DefaultLayout>
          <Home />
        </DefaultLayout>
      // </AuthGuard>
    },

    { path: '*', element: <Navigate to="/404" replace /> },

    ...errorRoutes,
  ]);
}
